<div class="bg-white p-5">
  <h2 class="text-lg font-bold mb-4 text-dc-navy">
    {{ "BUSINESS_GROUP.TITLE" | translate }}
  </h2>

  <div class="grid md:grid-cols-2 gap-6">
    @for (m of memberships; track m) {
      <div class="border border-dc-navy p-5 relative">
        <h2 class="text-dc-navy font-semibold mb-2">{{ m.name }}</h2>
        <div class="flex gap-2 mb-4">
          <span class="dc-status dc-status-active w-auto!">
            {{
              "BUSINESS_GROUP.LICENSE_ACTIVE"
                | translate: { licenseStatus: m.status }
            }}
          </span>
        </div>
        <div class="flex gap-10">
          <div class="text-dc-navy text-sm">
            <div class="mb-2">
              {{ "BUSINESS_GROUP.NUM" | translate }}
              <div class="font-semibold">{{ m.membershipNumber }}</div>
            </div>
            <div class="mb-2">
              {{ "BUSINESS_GROUP.EXP" | translate }}
              <div class="font-semibold">{{ m.expiryDate }}</div>
            </div>
          </div>

          <!-- right column -->
          <div class="text-dc-navy text-sm">
            <div class="mb-2">
              {{ "BUSINESS_GROUP.LIC" | translate }}
              <div class="font-semibold">{{ m.tradeLicense }}</div>
            </div>
            <div class="mb-2">
              {{ "BUSINESS_GROUP.USERS" | translate }}
              <div class="font-semibold">{{ m.activeUsers }}</div>
            </div>
          </div>
        </div>
        <!-- Actions -->

        <div class="dc-card-stretch-actions">
          <div class="flex flex-wrap gap-4 mt-4">
            @if(m.status == 'action-required') {
              <app-button
                classesName="btn-edge-cut"
                [label]="'BUTTONS.ACCEPT' | translate"
                (onBtnClick)="false"
              />
              <app-button
                classesName="card-edge-cut-white"
                [label]="'BUTTONS.REJECT' | translate"
                (onBtnClick)="false"
              />
            } @else {
              <app-button
                classesName="card-edge-cut-white"
                [label]="'BUTTONS.VIEW_DETAILS' | translate"
                (onBtnClick)="viewGroup(m)"
              />
            }
          </div>
        </div>
        <!-- corner decoration -->
        <span
          [ngClass]="{
            'border-b-dc-navy': m.status === 'active',
            'border-b-dc-orange': m.status === 'action-required',
          }"
          class="absolute w-0 h-0 border-l-[16px] border-b-[16px] border-l-transparent bottom-0 right-0"
        ></span>
      </div>
    } @empty {
      <p>{{ "BUSINESS_GROUP.GROUPS_LIST.EMPTY" | translate }}</p>
    }
  </div>
</div>